import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

/* eslint-disable */
window.Cam4User = {};

/**
 * broadcasting window reference
 * @const {Object}
 */
Cam4User.broadcastWindow = 'unset';
/**
 * broadcasting window width
 * @const {Number}
 */
Cam4User.broadcastWindowHeight = 675;
/**
 * broadcasting window height
 * @const {Number}
 */
Cam4User.broadcastWindowWidth = 1200;

/**
 * Open the broadcast window
 * @return {Object}
 */
Cam4User.broadcastStart = function () {
  if (Cam4User.isLoggedInAsGuest) {
    Registration.activateGuestRegisterModal();
    return;
  }

  //  if (EverCookie.getInt('preferredBroadcastWidth') > 0) {
  //    Cam4User.broadcastWindowWidth = EverCookie.getInt('preferredBroadcastWidth');
  //  }
  //
  //  if (EverCookie.getInt('preferredBroadcastHeight') > 0) {
  //    Cam4User.broadcastWindowHeight = EverCookie.getInt('preferredBroadcastHeight');
  //  }

  var tstamp = new Date().getTime();
  var url = BASE_URL + '/broadcast/broadcast.jsp?' + tstamp + '&responsiveMode=true';

  function openAndFocus() {
    Cam4User.broadcastWindow = window.open(
      url,
      'cam4Brd',
      'resizable=yes,height=' + Cam4User.broadcastWindowHeight + ',width=' + Cam4User.broadcastWindowWidth
    );
    if (!Cam4User.broadcastWindow) {
      window.location.href = url;
      return;
    }
    Cam4User.broadcastWindow.__parentWindow = window;
    return Cam4User.broadcastWindow.focus();
  }

  function hasLocationAndHref() {
    if (navigator.userAgent.match(/firefox/i)) {
      try {
        return typeof Cam4User.broadcastWindow.location === typeof {} && Cam4User.broadcastWindow.location.href !== '';
      } catch (ex) {
        return false;
      }
    }
    if (typeof Cam4User.broadcastWindow === 'undefined') {
      return false;
    }
    return (
      typeof Cam4User.broadcastWindow.location === typeof {} &&
      typeof Cam4User.broadcastWindow.location.href !== 'undefined'
    );
  }

  if (Cam4User.broadcastWindow === 'unset') {
    return openAndFocus();
  }

  if (!hasLocationAndHref()) {
    return openAndFocus();
  }

  if (hasLocationAndHref()) {
    try {
      if (Cam4User.broadcastWindow.location.href === 'about:blank') {
        Cam4User.broadcastWindow.location = url;
        return Cam4User.broadcastWindow.focus();
      }
    } catch (ex) {
      return openAndFocus();
    }
  }

  return Cam4User.broadcastWindow.focus();
};

export default Cam4User;
